import { jsx } from "@ecopages/jsx/jsx-runtime";
import "./toast.script";
import "./toaster.script";
export function RuiToast({
  toastId,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-toast", {
    ...props,
    toastId: toastId != null ? String(toastId) : void 0
  });
}
export function RuiToaster({
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-toaster", {
    ...props,
    children
  });
}